var _path, _g, _path2, _g2, _path3, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBenzingaAi = function SvgBenzingaAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 135 15",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_14",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 109,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H108.311V15H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.4743 2.57507V0.000976562H43.4094V2.78609H50.3571L43.4094 12.3798V14.9303H54.5901V12.1452H47.4815L54.4743 2.57507ZM56.9821 0.000976562H60.1333V14.9999H56.9821V0.000976562ZM98.3211 9.64177L100.622 3.20708L102.923 9.64177H98.3211ZM102.6 0.000976562H96.5499L97.9995 1.89593L97.7464 2.6222L93.0535 14.9763H96.596L97.5169 12.4494H103.843L104.763 14.9763H108.305L102.6 0.000976562ZM73.454 9.40718L66.621 0.000976562H61.9516L63.4012 1.89593V14.9763H66.5524V5.17273L73.5913 14.9303H76.5826V0.000976562H73.454V9.40718ZM87.6014 9.40718H89.2344V11.1629C88.3841 11.8645 87.3259 12.263 86.2215 12.2855C83.599 12.2855 81.7581 10.2502 81.7581 7.51222C81.7581 4.77424 83.6215 2.73896 86.2215 2.73896C87.5779 2.73896 88.8441 3.46416 89.5796 4.63391L92.0639 3.23064C91.0067 1.52208 89.1422 0.000976562 86.198 0.000976562C82.0336 0.000976562 78.5833 2.92642 78.5833 7.46509C78.5833 12.0048 81.9886 14.9303 86.198 14.9303C88.4988 14.9763 90.684 13.9705 92.2022 12.2394V6.71632H85.485L87.6014 9.40718ZM8.62676 12.1687H4.55464V8.72911H8.62676C9.8233 8.72911 10.4902 9.50144 10.4902 10.4366C10.4902 11.5132 9.7772 12.1452 8.62676 12.1687ZM4.55464 2.80859H8.48846C9.5467 2.80859 10.2136 3.4406 10.2136 4.37682C10.2136 5.31305 9.5467 5.94399 8.48846 5.94399H4.55464V2.80859ZM10.8354 7.25514C12.2154 6.99805 13.3658 5.6869 13.3658 3.83908C13.3658 1.84987 11.9398 0.000976562 9.10927 0.000976562H0L1.42601 1.84987V14.9538H9.43197C12.2615 14.9538 13.7336 13.1521 13.7336 10.9058C13.6649 9.05689 12.4223 7.46509 10.8354 7.25514ZM38.487 9.40718L31.6776 0.000976562H26.9846L28.4567 1.89593V14.9763H31.5854V5.17273L38.6243 14.9303H41.6381V0.000976562H38.487V9.40718ZM15.5745 14.9303H25.9725V12.1452H18.7256V8.72911H24.7298V5.94399H18.7256V2.78609H26.0186V0.000976562H15.5745",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_14",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 115,
    y: 0,
    width: 16,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.652 0H130.863V15H115.652V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.191 2.76253L120.807 9.6332H125.553L123.191 2.76253ZM127.293 14.9763L126.39 12.3947H119.991L119.09 14.9763H115.74L121.28 0.000976562H125.101L130.62 14.9763",
    fill: "rgb(63, 131, 248)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_14",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 131,
    y: 0,
    width: 4,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.914 0H134.999V15H131.914V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.949 14.9763H134.998V0.000976562H131.949V14.9763Z",
    fill: "rgb(63, 131, 248)"
  }))));
};
export { SvgBenzingaAi as ReactComponent };